import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export const useGenerateCustomsQueryTestFile = () => {
  return useMutation({
    // eslint-disable-next-line max-statements
    mutationFn: async () => {
      const response = await request(
        {
          path: `declarant/generate-customs-query-test-file`,
          method: 'POST',
          authenticate: true,
          fileDownload: true,
        },
        true,
      );

      const binaryData = [];
      binaryData.push(response.data);
      const href = window.URL.createObjectURL(new Blob(binaryData, { type: 'application/xml' }));
      const link = document.createElement('a');
      link.href = href;

      const [, filename] = response.headers['content-disposition'].match(/attachment; filename="(.*)"/i);

      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    onSuccess: () => {
      toast.success('File generation initiated!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error generating the file!');
    },
  });
};
